var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9611_210)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9611_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 18.375L19.6875 2.625C19.6875 1.90312 19.0969 1.3125 18.375 1.3125L2.625 1.3125C1.90313 1.3125 1.3125 1.90312 1.3125 2.625L1.3125 12.4687L2.625 12.4687C4.4625 12.4687 5.90625 13.9125 5.90625 15.75L7.21875 15.75C7.21875 13.1906 5.18437 11.1562 2.625 11.1562L2.625 9.1875L5.25 9.1875L5.25 7.875L2.625 7.875L2.625 2.625L18.375 2.625L18.375 7.875L9.1875 7.875L9.1875 9.1875L12.4687 9.1875L12.4687 11.8125L13.7812 11.8125L13.7812 9.1875L18.375 9.1875L18.375 18.375L13.7812 18.375L13.7812 15.75L12.4687 15.75L12.4687 18.375L2.625 18.375L2.625 15.75L1.3125 15.75L1.3125 18.375C1.3125 19.0969 1.90312 19.6875 2.625 19.6875L18.375 19.6875C19.0969 19.6875 19.6875 19.0969 19.6875 18.375Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9611_210",
    x: -0.6875,
    y: 0.3125,
    width: 22.375,
    height: 22.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9611_210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9611_210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9611_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(21) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.29a9049ca4b5cc2088c71e2c7a5d8c96.svg";
export { ForwardRef as ReactComponent };